const oldSectorKpiHeaders = [
    'Assigned Sectors (Climate_Change_&Mitigation/Resource_Efficiency/Quality_of_Life_&Prosperity/Smart_&Reliable_Infrastructure)',
    'Sectors Weight PED',
    'Sectors Weight Building',
    'Sectors Weight CITY',
    'Sectors Weight PEB',
]

const aggLevels = ['Building', 'PEB', 'PED', 'City']
const sectorsShortened = [
    'Sector Weight Climate Change & Mitigation',
    'Sector Weight Resource Efficiency',
    'Sector Weight Quality of Life & Prosperity',
    'Sector Weight Smart & Reliable Infrastructure'
]
const newSectorKpiHeaders = sectorsShortened.flatMap(sector => aggLevels.map(level => `${sector} ${level}`));

const validKpiHeaders = [
    'KPI (text)',
    'Functional Unit (text)',
    'Assigned Dimension',
    'Aggregation Level Building',
    'Dimension Weight Building',
    'Value (Building)',
    'Aggregation Level PEB',
    'Dimension Weight PEB',
    'Value (PEB)',
    'Aggregation Level PED',
    'Dimension Weight PED',
    'Value (PED)',
    'Aggregation Level CITY',
    'Dimension Weight CITY',
    'Value CITY',
    'Failed (double number)',
    'Underachieved (double number)',
    'Achieved (double number)',
    'Overachieved (double number)',
]

const validPsiHeaders = [
    'PSI (text)',
    'Functional Unit (text)',
    'Call Impact',
    'Failed (double number)',
    'Underachieved (double number)',
    'Achieved (double number)',
    'Overachieved (double number)',
    'Value (double number)',
    'Target Value (double number)'
]

/**
 * Checks the validity of the headers by comparing them to the actual values
 * that should be present. The comparison is done by converting the header
 * lists into Sets and taking their mathematical difference. If the difference
 * is empty, it means that the file is most likely 100% okay. Otherwise, a header
 * might be missing or faulty.
 * @param headers A list of headers to check
 * @param isPsi Boolean value that will point to the PSIs if it's set to true
 * @return {Set<string>} The difference between the actual headers and the expected ones
 */
const validateHeaders = (headers, isPsi) => {
    const trimmedHeaders = headers.map(h => h.trim())

    const modifiedValidKpiHeaders = containsNewHeaders(headers) ? validKpiHeaders.concat(newSectorKpiHeaders) : validKpiHeaders.concat(oldSectorKpiHeaders)

    const setHeaders = new Set(isPsi ? validPsiHeaders : modifiedValidKpiHeaders)
    const currentHeaders = new Set(trimmedHeaders)

    return setHeaders.difference(currentHeaders)
}

/**
 * We determine the presence of the new headers by looking at the old headers. Specifically, we want to detect if the
 * first element of the `oldSectorKpiHeaders` is present. If it is, then it means that the old headers are the ones
 * to be selected.
 * @param headers The array of headers
 * @return {boolean} True if the new headers should be used, false otherwise.
 */
export const containsNewHeaders = (headers) => {
    const trimmedHeaders = headers.map(h => h.trim());
    return !trimmedHeaders.includes(oldSectorKpiHeaders[0]);
}

export const validateKpiHeaders = (headers) => {
    return validateHeaders(headers, false)
}

export const validatePsiHeaders = (headers) => {
    return validateHeaders(headers, true)
}

export const containsBenchmarkHeader = (headers) => {
    const trimmedHeaders = headers.map(h => h.trim())
    return trimmedHeaders.includes('Benchmark Value (double number)')
}